/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Event_Ad_Preview_Audio_TitleInputs */

const en_event_ad_preview_audio_title = /** @type {(inputs: Event_Ad_Preview_Audio_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Preview event audio`)
};

const fr_event_ad_preview_audio_title = /** @type {(inputs: Event_Ad_Preview_Audio_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Previsualiser l'audio de l'evenement`)
};

const de_event_ad_preview_audio_title = /** @type {(inputs: Event_Ad_Preview_Audio_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vorschau der Veranstaltung (Audio)`)
};

const it_event_ad_preview_audio_title = /** @type {(inputs: Event_Ad_Preview_Audio_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anteprima audio dell'evento`)
};

const ru_event_ad_preview_audio_title = /** @type {(inputs: Event_Ad_Preview_Audio_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Предварительный просмотр аудиособытия`)
};

const es_event_ad_preview_audio_title = /** @type {(inputs: Event_Ad_Preview_Audio_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vista previa del audio del evento`)
};

const zh_cn2_event_ad_preview_audio_title = /** @type {(inputs: Event_Ad_Preview_Audio_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`预览活动音频`)
};

const ja_event_ad_preview_audio_title = /** @type {(inputs: Event_Ad_Preview_Audio_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`イベント音声のプレビュー`)
};

const hi_event_ad_preview_audio_title = /** @type {(inputs: Event_Ad_Preview_Audio_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`इवेंट ऑडियो का पूर्वावलोकन करें`)
};

const pt_pt2_event_ad_preview_audio_title = /** @type {(inputs: Event_Ad_Preview_Audio_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pré-visualização do áudio do evento`)
};

/**
* | output |
* | --- |
* | "Preview event audio" |
*
* @param {Event_Ad_Preview_Audio_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const event_ad_preview_audio_title = /** @type {((inputs?: Event_Ad_Preview_Audio_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Event_Ad_Preview_Audio_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_event_ad_preview_audio_title(inputs)
	if (locale === "de") return de_event_ad_preview_audio_title(inputs)
	if (locale === "it") return it_event_ad_preview_audio_title(inputs)
	if (locale === "ru") return ru_event_ad_preview_audio_title(inputs)
	if (locale === "es") return es_event_ad_preview_audio_title(inputs)
	if (locale === "zh-CN") return zh_cn2_event_ad_preview_audio_title(inputs)
	if (locale === "ja") return ja_event_ad_preview_audio_title(inputs)
	if (locale === "hi") return hi_event_ad_preview_audio_title(inputs)
	if (locale === "pt-PT") return pt_pt2_event_ad_preview_audio_title(inputs)
	return en_event_ad_preview_audio_title(inputs)
});